module.exports = "  <div class=\"header\"\n       fxLayout=\"row\"\n       fxLayoutAlign=\"center center\"\n       fxFlex=\"90\"\n       fxFlex.xs=\"90\"\n       fxFlex.sm=\"80\">\n    <div class=\"headerContent\" style=\"background-image: url('static/logo.png')\">\n    </div>\n  </div>\n"


//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/src/app/header/header.component.html
// module id = ../../../../../src/app/header/header.component.html
// module chunks = 0